module.exports = "<nav-bar *ngIf=\"primary\"></nav-bar>\n<div id=\"main_content\" [ngStyle]=\"{'min-height': 'calc(100vh - ' + ((state.footer.show_banner ? footerHeight + bannerHeight : footerHeight) + mobileAddition) + 'px)'}\">\n    <router-outlet></router-outlet>\n</div>\n<footer-bar *ngIf=\"primary\"></footer-bar>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main